import { render, staticRenderFns } from "./downFile.vue?vue&type=template&id=3f8ca053&"
import script from "./downFile.vue?vue&type=script&lang=js&"
export * from "./downFile.vue?vue&type=script&lang=js&"
import style0 from "./downFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports